import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

import '../styles/componentStyles/CircleGraph.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function CircleGraph(props) {
  const { t } = useTranslation();
  const titleId = props.title?.replace(/\s+/g, '');
  return (
    <div
      className={`chart-container ${props.width}`}
      role="group"
      aria-labelledby={`${titleId}-circle-graph-title ${titleId}-circle-graph-value ${titleId}-circle-graph-descriptor`}
    >
      <div className="title-container" aria-hidden="true">
        <h3 className="title" id={`${titleId}-circle-graph-title`}>
          {props.title}
        </h3>
        <button
          className="wtf transparent-button"
          onClick={() => props.openModal(props.title, props.modalText)}
        >
          <span className="visuallyHidden">{t('open.modal.extra.information')}</span>
          <FontAwesomeIcon icon={faQuestionCircle} className="wtf icon" />
        </button>
      </div>
      <div className="chart-box" aria-hidden="true">
        <div className="circle_chart">
          {props.icon && <FontAwesomeIcon icon={props.icon} className="chart-icon" />}
          {props.value && (
            <p
              className="fs-mask"
              style={{ color: props.colour }}
              id={`${titleId}-circle-graph-value`}
            >
              {props.value}
            </p>
          )}
          {props.discriptor && (
            <span id={`${titleId}-circle-graph-descriptor`}>{props.discriptor}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default CircleGraph;
